import Vue from 'vue';
import Cookies from 'js-cookie';
import {vm} from '@/main';
import moment from 'moment';

const state = {
    locale: Cookies.get('locale'),
    translations: {},
    locales: {
        en: 'EN',
        et: 'ET'
    },
    langs: [
        { key: 'et', name: 'Estonian' },
        { key: 'en', name: 'English' }
    ]
};

const mutations = {
    ['SET_LOCALE'](state, locale) {
        state.locale = locale;
        Cookies.set('locale', locale, { expires: 365 });
    },

    ['SET_TRANSLATIONS'](state, { locale, messages }) {
        Vue.set(state.translations, locale, messages);
        vm.$i18n.locale = locale;
        let momentLocale = locale;
        if (momentLocale === 'en') {
            momentLocale = 'en_gb';
        }
        moment.locale(momentLocale);
        vm.$i18n.setLocaleMessage(locale, messages);
    },
};

const actions = {
    async ['SET_LOCALE']({ commit, getters }, locale) {
        if (!locale) throw new TypeError('Can\'t find lang parameter');
        if (getters.locale !== locale || !getters.hasTranslatations(locale)) {
            const messages = await import(/* webpackChunkName: "lang-[request]" */ `@/lang/${locale}`);
            commit('SET_LOCALE', locale);
            commit('SET_TRANSLATIONS', { locale, messages });
        }
    }
};

const getters = {
    langs: state => state.langs,
    locale: state => state.locale,
    localeDateFormat: state => state.locale === 'et' ? 'DD.MM.YYYY' : 'DD/MM/YYYY',
    localeDatetimeFormat: state => state.locale === 'et' ? 'DD.MM.YYYY HH:mm' : 'MM/DD/YYYY HH:mm',
    locales: state => state.locales,
    hasTranslatations: state => locale => {
        return !!state.translations[locale];
    }
};

export default {
    state,
    mutations,
    actions,
    getters
};
